import { connect } from "react-redux";
import { SupplyAddressPage } from "../screens/SupplyAddressPage";
import { supplyAddressChangeTextField, supplyAddressResetError, supplyAddressFormValidateAndSubmit, supplyAddressFilterEnergyList, supplyAddressFilterGasList, supplyAddressFormGetProviders, addressPlaceNameFilter } from "../reducers/supplyAddressForm";
import { provincesGet, provincesSetMunicipality } from "../reducers/provinces";

function mapStateToProps(state) {
    const form = state.supplyAddressForm;
    const offer = state.offer;
    const { list: provinces, municipality, residenceMunicipality, gasSupplyMunicipality } = state.provinces;
    const { list: energySuppliers } = state.supplierEnergyReducer;
    const { list: gasSuppliers } = state.supplierGasReducer;
    const consumption = state.consumptionReducer;
    const powerList = state.powerReducer.list;

    return {
        form, offer, provinces, municipality, energySuppliers, 
        gasSuppliers, consumption, powerList, residenceMunicipality, gasSupplyMunicipality
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onChangeText: (name, value) => dispatch(supplyAddressChangeTextField(name, value)),
        resetError: name => dispatch(supplyAddressResetError(name)),
        getProvinces: (municipality) => dispatch(provincesGet(municipality)),
        setMunicipality: (municipality, type) => dispatch(provincesSetMunicipality(municipality, type)),
        validate: successCallback => dispatch(supplyAddressFormValidateAndSubmit(successCallback)),
        supplyAddressFilterEnergyList: value => dispatch(supplyAddressFilterEnergyList(value)),
        supplyAddressFilterGasList: value => dispatch(supplyAddressFilterGasList(value)),
        getProviders: () => dispatch(supplyAddressFormGetProviders()),
        addressPlaceNameFilter: value => dispatch(addressPlaceNameFilter(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplyAddressPage);